import { render, staticRenderFns } from "./c-schedule-item.vue?vue&type=template&id=177ce8c2&scoped=true"
import script from "./c-schedule-item.vue?vue&type=script&setup=true&lang=js"
export * from "./c-schedule-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-schedule-item.vue?vue&type=style&index=0&id=177ce8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ce8c2",
  null
  
)

export default component.exports